import { type FormEvent, useState } from 'react'
import { authCopy } from '@/copy'
import { Alert } from '@/ui/Alert/Alert'
import { Button } from '@/ui/Button/Button'
import { TextField } from '@/ui/Field/Field'
import { Stack } from '@/ui/layout/Stack'
import { forgotPassword } from '../api/auth'
import { AuthLink, AuthShell } from '../components/AuthShell'
import { ROUTES } from '../constants/routes'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  // Not using useAsyncSubmit here on purpose: this flow deliberately shows a
  // generic message on any failure (never the server's error) so it can't leak
  // whether an email is registered.
  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await forgotPassword(email)
      setSubmitted(true)
    } catch {
      setError(authCopy.forgot.failed)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell heading={authCopy.forgot.heading}>
      {submitted ? (
        <Stack gap="space-16">
          <Alert tone="success">{authCopy.forgot.sent}</Alert>
          <AuthLink href={ROUTES.login}>{authCopy.backToSignIn}</AuthLink>
        </Stack>
      ) : (
        <Stack as="form" gap="space-16" onSubmit={(e) => void handleSubmit(e)}>
          <TextField
            id="email"
            label={authCopy.forgot.email}
            value={email}
            onValue={setEmail}
            inputProps={{
              type: 'email',
              autoComplete: 'email',
              required: true,
            }}
          />
          {error && <Alert tone="danger">{error}</Alert>}
          <Button type="submit" variant="primary" loading={loading}>
            {authCopy.forgot.submit}
          </Button>
          <AuthLink href={ROUTES.login}>{authCopy.backToSignIn}</AuthLink>
        </Stack>
      )}
    </AuthShell>
  )
}
